/*@ngInject*/
const UIColumnResizeDirective = function ($rootScope, $document, formViewerConstant) {

    let linkFunction = function ($scope, $elm, $attr) {

        let element = $($elm),
            uiColumnResizeIdentifier = $attr.uiColumnResizeIdentifier,
            columnElement = element.parent(),
            resizeActive = false,
            startWidth,
            startClientX;

        function initColumnResize(event) {
            startWidth = columnElement.width();
            startClientX = event.clientX;
            resizeActive = true;

            event.preventDefault();
        }

        function resizeColumn(event) {
            if (resizeActive) {
            	let offsetX = event.clientX - startClientX,
                newWidth = startWidth + offsetX;

                columnElement.width(startWidth + offsetX);

                $rootScope.$broadcast(formViewerConstant.event.formBuilder.COLUMN_RESIZING);
            }
        }

        function stopColumnResize(event) {
            let offsetX = event.clientX - startClientX,
                newWidth = startWidth + offsetX;

            if (resizeActive) {
                $rootScope.$broadcast(formViewerConstant.event.formBuilder.COLUMN_RESIZED, uiColumnResizeIdentifier, newWidth);

                resizeActive = false;
            }
        }

        $document.on('mousemove.uiColumnResize', resizeColumn);
        $document.on('mouseup.uiColumnResize', stopColumnResize);
        element.on('mousedown', initColumnResize);

        $scope.$on('$destroy', function () {
            element.off('mousedown', initColumnResize);
            $document.off('mousemove.uiColumnResize', resizeColumn);
            $document.off('mouseup.uiColumnResize', stopColumnResize);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umFormViewer')
    .directive('uiColumnResize', UIColumnResizeDirective);
